import legalLinksTemplate from './legal-links.tpl.html';

export const legalLinksComponentModule = angular
  .module('Q.components.legal-links', [])
  .component('legalLinks', {
    bindings: {
      hideContact: '<',
    },
    template: legalLinksTemplate,
  });
